import React from 'react';
import { BLUE } from 'style/colors';
import Section from 'components/UIKit/Details/Content/Section';
import Table, { THead, TBody, Tr, Td, Th } from 'components/UIKit/Table';
import DownloadContainer from 'containers/DownloadContainer';

let styles = {
  dlBtn: {
    cursor: 'pointer',
    color: BLUE
  },
  table: {
    border: '1px solid #e5e5e5',
  }
};

let TransactionError = ({ tx }) => {
  return (
    <Section id="error">
      <span>An error occurred during the transaction.</span>
      <Table style={styles.table}>
        <THead>
          <Tr>
            <Th>Filename</Th>
            <Th>Message</Th>
          </Tr>
        </THead>
        <TBody>
          {tx.documents.map(doc =>
            <Tr key={doc.name}>
              <Td>
                <DownloadContainer
                  body={doc.doc}
                  format={doc.doc_format}
                  filename={doc.name}
                >
                  <span style={styles.dlBtn}>{doc.name || '...'}</span>
                </DownloadContainer>
              </Td>
              <Td>doc.response.message</Td>
            </Tr>
          )}
        </TBody>
      </Table>
    </Section>
  );
};

export default TransactionError;
